import { render, staticRenderFns } from "./NotificationsMailLogOverview.vue?vue&type=template&id=625e21cc&scoped=true&"
import script from "./NotificationsMailLogOverview.vue?vue&type=script&lang=js&"
export * from "./NotificationsMailLogOverview.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsMailLogOverview.vue?vue&type=style&index=0&id=625e21cc&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625e21cc",
  null
  
)

export default component.exports